'use strict';

/* Imports */
import 'simpleweather/jquery.simpleWeather.min';
import 'bootstrap/js/carousel';

/* Views */
import Home from './home.component';

/* Components */
import FeedbackFormComponent from '../../components/feedback-form/feedback-form.component';
import WeatherDirective from '../../components/weather/weather.directive';

export default angular.module('conduuApp.home', [Home, FeedbackFormComponent, WeatherDirective])
  .name;



// WEBPACK FOOTER //
// ./client/app/home/index.js